import React, { useEffect, useState } from 'react'
import Pagination from '../../common/Pagination';
import Table from './Table';
import { Link } from 'react-router-dom';
import Header from '../../common/Header';
import { useAdminContext } from '../../../context/adminContext';
import { debounce } from 'lodash';
import { addEntertainmentToCarouselApi, getAllAddedCarouselEntertainmentApi, getAllUnCarouselEntertainmentApi, removeEntertainmentFromCarouselApi } from '../../../utils/ApiEndpointFunctions';
import toast from 'react-hot-toast';
import AddCrouselModal from '../../common/AddCrouselModal';
import { useFormik } from 'formik';
import ModalVideo from './ModalVideo';
import { manageCarouselIntialValue, manageCarouselValidationSchema } from '../../common/Validation';
import CarouselTable from './CarouselTable';
import RemoveModal from '../../common/RemoveModal';

function ManageEntertainmentCarousel() {

  const { adminDetail } = useAdminContext();
  let [selectedPage, setSelectPage] = useState(0);
  const [entertainment, setEntertainment] = useState([]);
  const [removeData, setRemoveData] = useState(null);
  const [tableSpin, setTableSpin] = useState(true);
  const [entertainmentData, setEntertainmentData] = useState({});
  const carouselModalId = "carouselModalID";
  const removeCarouselModalId = "removeCarouselModalId"
  const [carouselOptions, setCarouselOptions] = useState([]);
  const [modalUpdate, setModalUpdate] = useState({
    id: "",
    status: false,
    type: ""
  })

  const [page, setPage] = useState(0);
  let [type, setType] = useState("inshorts")
  const [searchText, setSearchText] = useState("");
  const limit = 10;

  const getAllAddedCarouselNews = async () => {
    setTableSpin(false)
    const res = await getAllAddedCarouselEntertainmentApi(limit, selectedPage + 1, searchText)
    if (res.status === 200) {
      const totalData = res.data?.totalData
      setPage(Math.ceil(totalData / limit));
      setEntertainment(res.data?.data)
      setTableSpin(true)
    }
  }

  const getAllUnCarouselNews = async () => {
    const res = await getAllUnCarouselEntertainmentApi('')
    if (res.status === 200) {
      setCarouselOptions(res.data?.data?.map((ele, index) => {
        return {
          label: ele?.title,
          value: ele
        }
      }))

    }

  }

  const onChange = async (e) => {
    let search = e.target.value;
    setTableSpin(false);
    setSearchText(search)
    const res = await getAllAddedCarouselEntertainmentApi(limit, 1, search);
    if (res.status === 200) {
      setEntertainment(res.data?.data);
      const totalData = res.data?.totalData
      setPage(Math.ceil(totalData / limit));
      setSelectPage(0)
      setTableSpin(true);
    }
  };

  const debouncedOnChange = debounce(onChange, 500);

 

  useEffect(() => {
    getAllAddedCarouselNews();
  }, [])

  const handlePageClick = (event) => {
    selectedPage = event.selected
    setSelectPage(event.selected);
    getAllAddedCarouselNews(event.selected);
  };

  const addCarousel = async (values) => {
    try {
      document.getElementById(carouselModalId).click()
      
      const res = await addEntertainmentToCarouselApi({ id: values.id?._id });
      if (res.status === 200) {
        toast.success(res.data?.message)
        getAllAddedCarouselNews(selectedPage, type);
      }
    } catch (error) {
      toast.error("Something went wrong")
    }
  }

  const handleRemoveData = async (data) => {
    try {
      document.getElementById(removeCarouselModalId).click();
      const res = await removeEntertainmentFromCarouselApi({ _id: removeData })
      if (res.status === 200) {
        getAllAddedCarouselNews()
        toast.success(res.data?.message)
      }
    } catch (error) {
      toast.error("Something went wrong")
    }
  }

  const carouselFormik = useFormik({
    initialValues: manageCarouselIntialValue,
    onSubmit: addCarousel,
    validationSchema: manageCarouselValidationSchema
  })

  return (
    <>
      {/*<Sidebar />*/}
      <div className="main-content vh-100 vh_md-auto overflow-y-a">
        <Header title="Entertainment" />
        <div className="container-fluid">
          <div className="row">
            <nav className="mb-5">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard" >
                    <i className="fe fe-home"></i> Dashboard
                  </Link>
                </li>
                <Link to="/entertainment" className="breadcrumb-item active" aria-current="page">
                  Entertainment
                </Link>
                <li className="breadcrumb-item active" aria-current="page">
                  Carousel
                </li>
              </ol>
            </nav>
            <div className="d-flex justify-content-end mb-4 flex-wrap">
              <div className='d-flex gap-3 justify-content-end align-items-center' style={{ display: "-webkit-inline-box" }}>
                <div className="btn-custom" data-bs-toggle="modal" data-bs-target={`#${carouselModalId}`} onClick={() => { carouselFormik.resetForm(); getAllUnCarouselNews() }}>
                  Add
                </div>
                <div className="position-relative">
                  <input
                    className="form-search me-3"
                    type="search"
                    name=""
                    onChange={debouncedOnChange}
                    placeholder="Search"
                  />
                  <img
                    className="users-search"
                    src="/images/Icon feather-search.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <hr />

            <div className="card p-3 ">
              <CarouselTable

                selectedPage={selectedPage}
                limit={limit}
                tableData={entertainment}
                setTableData={setEntertainment}
                setRemoveData={setRemoveData}
                tableSpin={tableSpin}
                setModalUpdate={setModalUpdate}
                setEntertainmentData={setEntertainmentData}
                carouselFormik={carouselFormik}
                carouselModalId={carouselModalId}
                resetTableData={getAllAddedCarouselNews}
              />
            </div>
          </div>
          <div className="d-flex justify-content-center">
            {entertainment?.length > limit ? <Pagination
              clickHandler={handlePageClick}
              page={page}
              selectedPage={selectedPage}
            /> : null}
          </div>
        </div>
      </div>
      <AddCrouselModal modalId={carouselModalId} formik={carouselFormik} title="Select entertainment" options={carouselOptions} currentValue={carouselFormik?.values?.id ? { label: carouselFormik?.values?.id?.title, value: carouselFormik?.values?.id } : null} />
      <ModalVideo

        showModalData={entertainmentData}
        setShowModalData={setEntertainmentData}
      />

      <RemoveModal removeHandler={handleRemoveData} modalId={removeCarouselModalId} message={<>Are you sure you want to<br /> remove this?</>} />
    </>
  )
}

export default ManageEntertainmentCarousel